import { render, staticRenderFns } from "./SrsParsing.vue?vue&type=template&id=f504a9a8&scoped=true&"
import script from "./SrsParsing.vue?vue&type=script&lang=ts&"
export * from "./SrsParsing.vue?vue&type=script&lang=ts&"
import style0 from "./SrsParsing.vue?vue&type=style&index=0&id=f504a9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f504a9a8",
  null
  
)

export default component.exports